import { render, staticRenderFns } from "./affiliate-assessment-entrepreneur.vue?vue&type=template&id=4fdb427a&scoped=true&"
import script from "./affiliate-assessment-entrepreneur.vue?vue&type=script&lang=ts&"
export * from "./affiliate-assessment-entrepreneur.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-assessment-entrepreneur.vue?vue&type=style&index=0&id=4fdb427a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb427a",
  null
  
)

export default component.exports